import { terrabusiness } from '@/services/api-config';

interface Agent {
  nmAgent: string;
  vlDocument: string;
  dbOperation?: string;
}

interface RequestSource {
  fkSystem?: string;
  fkUser: string;
}

interface Territory {
  cdTerritory: string;
  vlStatus: string;
  dbOperation: string;
}

export interface AgentParms {
  agents?: Agent[];
  territories?: Territory[];
  requestSource: RequestSource;
}

export const createAgent = async (params: AgentParms) => {
  const tmxToken = sessionStorage.getItem('chave');
  const userLogged = JSON.parse(sessionStorage.getItem('userLogged') as string);

  return terrabusiness
    .post(`api/business/create/newRecord?tokenKey=${userLogged.company.stKey}`, params, {
      headers: {
        Authorization: `${tmxToken}`,
      },
    })
    .then((response) => response.data)
    .catch((err) => ({ hasErrors: true, message: err.message }));
};
